import React from 'react';
import { CloseIcon } from '../../icons';

type CloseButtonProps = {
  iconClassName?: string;
  iconColor?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const CloseButton: React.FC<CloseButtonProps> = ({ iconClassName, iconColor, ...buttonProps }) => {
  return (
    <button {...buttonProps}>
      <CloseIcon className={iconClassName} color={iconColor} />
    </button>
  );
};
